import React from 'react';

export interface StatusDotProps extends React.HTMLAttributes<HTMLSpanElement> {
  colorClass?: string;
  pulse?: boolean;
}

export function StatusDot({
  className = 'w-1.5 h-1.5',
  colorClass = 'bg-brand-mint',
  pulse = false,
  ...props
}: StatusDotProps) {
  const rootClasses = `
    relative inline-flex shrink-0 rounded-full
    ${className}
  `.trim().replace(/\s+/g, ' ');

  const dotClasses = `block h-full w-full rounded-full ${colorClass}`;

  if (!pulse) {
    return <span {...props} className={`${rootClasses} ${colorClass}`} />;
  }

  return (
    <span {...props} className={rootClasses}>
      <span
        aria-hidden="true"
        className={`absolute inset-0 rounded-full ${colorClass} animate-[status-dot-pulse_3.2s_ease-out_infinite]`}
      />
      <span
        aria-hidden="true"
        className={`${dotClasses} animate-[status-dot-core-pulse_3.2s_ease-in-out_infinite]`}
      />
    </span>
  );
}

export default StatusDot;
